import { ProjectActions } from '@octopus-do/octopus-project-core'
import { initialColors } from '@store/reducers/manager/sagas/initProjectActions/colors/initialColors'

export const InitColorsAction = ProjectActions.colors.add({
  items: initialColors,
})
